import React from 'react';

import { ChartArea, ShimmerWrapper, TitleLine } from './AIInsightsUI.styles';

const ChartShimmer = () => (
  <ShimmerWrapper>
    <TitleLine />
    <ChartArea />
  </ShimmerWrapper>
);

export default ChartShimmer;
